
<template>
  <el-form-item :label="params.label">
    <el-autocomplete
      :class="params.className"
      size="small"
      clearable
      v-model="siteName"
      :value-key="params.queryStringKey"
      :fetch-suggestions="querySearchAsync"
      :placeholder="params.placeholder"
      @select="handleSelect"
      @clear="handleClear"
    ></el-autocomplete>
  </el-form-item>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'v-autocomplete',
  props: {
    params: {
      type: Object
    },
    rowData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'selfAreaId'
    ])
  },
  data() {
    return {
      // value: this.rowData ? this.rowData[this.params.key] : this.params.value,
      value: '',
      siteName: '',
      restaurants: []
    }
  },
  created() {
    if (this.params && this.params.apiKey === 'snyc') {
      // 同步请求一次
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      if (this.params && this.params.apiParamsKey) {
        params[this.params.apiParamsKey] = this.params.apiParamsKeyValue
      }
      Api.fetchApiGet(params, '/api/miApp/getAllDispatcherList')
        .then(res => {
          this.restaurants = res.data || []
        })
        .catch(err => {
          console.log('the getAllDispatcherList has problem:', err)
        })
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      const vm = this
      if (!queryString) {
        return false
      }
      if (this.params && this.params.apiKey === 'snyc') {
        var results = queryString ? vm.restaurants.filter(vm.createStateFilter(queryString, vm.params)) : vm.restaurants
        cb(results)
      } else if (this.params && this.params.apiKey === 'asnyc') {
        const params = {
          selfAreaId: vm.selfAreaId,
          name: queryString
        }
        if (this.params && this.params.apiParamsKey) {
          params[this.params.apiParamsKey] = this.params.apiParamsKeyValue
        }
        Api.fetchApiGet(params, vm.params.api)
          .then(res => {
            let restaurants = []
            if (res && res.data && res.data.length) {
              restaurants = res.data
            } else {
              vm.$message.warning('未查到相关信息')
            }
            cb(restaurants)
          })
          .catch(err => {
            console.log('the querySearchAsync has problem:', err)
          })
      }
    },
    createStateFilter(queryString, params) {
      return (state) => {
        console.log(state, params, queryString)
        return (state[params.queryStringKey].indexOf(queryString) !== -1)
      }
    },
    handleSelect(item) {
      this.value = item[this.params.valueKey]
    },
    handleClear() {
      console.log('handleClear')
      this.value = ''
      this.siteName = ''
    },
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
        this.siteName = this.params.dValue
      } else {
        this.value = undefined
        this.siteName = ''
      }
      this.restaurants = []
    },
    getValue() {
      if (this.value) {
        return {
          [this.params.key]: this.value
        }
      }
      return undefined
    }
  },
  watch: {
    value(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      this.$emit('csi', cp)
    }
  }
}
</script>
